module.exports = __webpack_public_path__ + "img/spot1.d3fab1bb.png";